export const autoformatOpts = {
    link: {
        trigger: /[\s]/,
        find: /https?:\/\/[\S]+|(www\.[\S]+)/gi,
        transform: (value, noProtocol) =>
            noProtocol ? `https://${value}` : value,
        format: 'link',
    },
    hashtag: {
        trigger: /[\s]/,
        find: /(?:^|)#[^\s.,;:!?]+/i,
        transform: (value) => value,
        format: 'hashtag',
    },
};
